import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=ddcd347a&scoped=true"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"
import style0 from "./overlay.vue?vue&type=style&index=0&id=ddcd347a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd347a",
  null
  
)

export default component.exports